module.exports = __webpack_public_path__ + "img/20190629103006243.d0ff8159.png";